import { Link } from 'react-router-dom'

function About() {
    return (
        <div className="bg-white pb-8">
            <div className="max-w-4xl mx-auto px-4 py-16">
                <h1 className="text-2xl font-medium text-gray-900 mb-8">
                    Welcome!
                </h1>

                <div className="grid grid-cols-1 lg:grid-cols-10 gap-8 lg:gap-12 lg:divide-x lg:divide-gray-200">
                    {/* Main Content - Left Column (70% width) */}
                    <div className="lg:col-span-7 space-y-6 text-gray-700 leading-relaxed lg:pr-12">
                        <p>
                        Signed is a personal project I started to help 100 people find a new job.
                        </p>
                        <p>
                        I'm not building the biggest job board. Just a really useful one.
                        </p>
                        <p>
                        Every job is sourced using data from the company's website. No paid ads.
                        </p>
                        <p>
                            If you have feedback or want to work with me, I'd love to hear from you.
                        </p>
                    </div>

                    {/* Projects - Right Column (30% width) */}
                    <div className="lg:col-span-3 lg:pl-0">
                        <h2 className="text-md font-medium text-gray-900 mb-4">Current Projects</h2>
                        <div className="space-y-3">
                                <a
                                    href="https://www.decimals.co/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-start gap-3 text-gray-700 hover:text-gray-900 transition-colors group"
                                >
                                    <div className="w-8 h-8 rounded-full overflow-hidden shrink-0 transition-transform group-hover:scale-110 group-hover:-rotate-3">
                                        <img
                                            src="/decimals.png"
                                            alt="Decimals"
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-sm font-medium">Decimals</div>
                                        <div className="text-xs text-gray-500">Hiring talent shouldn't be hard</div>
                                    </div>
                                </a>
                                <div className="flex items-start gap-3 text-gray-700">
                                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center text-white text-xs font-semibold shrink-0">
                                        SS
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-sm font-medium">Supporting Support</div>
                                        <div className="text-xs text-gray-500">coming soon</div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>

                {/* Signature */}
                <div className="pt-4 mt-4">
                    <p className="text-gray-700 mb-4">Thanks,</p>
                    <div className="flex items-center gap-4">
                        <a
                            href="https://www.linkedin.com/in/sdsc/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block w-12 h-12 rounded-full overflow-hidden bg-gray-100 border border-gray-200 flex-shrink-0 transition-transform hover:scale-110 hover:-rotate-3 cursor-pointer"
                        >
                            <img
                                src="/profile-photo.jpg"
                                alt="Susana"
                                className="w-full h-full object-cover"
                            />
                        </a>
                        <img
                            src="/signature.png"
                            alt="Susana de Sousa"
                            className="h-16 w-auto"
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default About
